import { defineAbility } from '@casl/ability'

// eslint-disable-next-line no-unused-vars
export default defineAbility((can) => {})
